interface IGamingConfig {
  api?: {
    httpApolloUrl?: string;
    legacyHttpApolloUrl?: string;
    wsApolloUrl?: string;
  };
  pushNotification?: {
    key?: string;
  };
}

export const GAMING_CONFIG: IGamingConfig = JSON.parse(
  import.meta.env.VITE_API_CFG || "{}",
);

export const isVodacomVersion =
  import.meta.env.VITE_HOMEPAGE_VERSION === "Vodacom";
